module.exports = __webpack_public_path__ + "static/img/individualMember.13cb6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/individualMember.png
// module id = SwGN
// module chunks = 1